import {HttpModelConverter} from "../../../../../core/converter/httpModel.converter";
import {InsolesProviderModelMaterialModel} from "./insolesProviderModelMaterial.model";
import {LovValueSummaryConverter} from "../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {Injectable} from "@angular/core";
import {InsoleMaterialSummaryConverter} from "../../../../material/api/entity/insoleMaterialSummary.converter";
import {InsolesProviderModelGabaritModel} from "./insolesProviderModelGabarit.model";
import {LovValueConverter} from "../../../../../common/lov/lov-value/api/converter/LovValue.converter";
import {InsolesProviderModelCamMachineModel} from "./insolesProviderModelCamMachine.model";
import {CamMachineSummaryConverter} from "../../../../../3d/cam/machine/api/model/camMachineSummary.converter";
import {
    ProviderServiceOptionSummaryModel
} from "../../../../../provider/service/option/api/entity/providerServiceOptionSummary.model";
import {
    ProviderServiceOptionSummaryConverter
} from "../../../../../provider/service/option/api/entity/converter/providerServiceOptionSummary.converter";

@Injectable({
    providedIn: 'root'
})
export class InsolesProviderModelCamMachineConverter extends HttpModelConverter<InsolesProviderModelCamMachineModel>{

    constructor(private camMachineSummaryConverter: CamMachineSummaryConverter,
                private providerServiceOptionSummaryConverter: ProviderServiceOptionSummaryConverter) {
        super();
    }

    protected createInstance(): InsolesProviderModelCamMachineModel {
        return new InsolesProviderModelCamMachineModel();
    }

    protected enrichObject(result: InsolesProviderModelCamMachineModel, src: InsolesProviderModelCamMachineModel) {
        result.camMachine = this.camMachineSummaryConverter.convert(src.camMachine);
        result.options = this.providerServiceOptionSummaryConverter.convertFromArray(src.options);
    }

}